// La notice de confidentialité (lot 5.2) : relisible à tout moment (Réglages), et à accepter avant d'utiliser Alfred
// quand l'instance l'exige et que la version a changé. Le texte vient du serveur, en Markdown.

import { useEffect, useState } from 'react';

import type { Actions } from '../App';
import { EnTeteRetour, Fenetre } from '../components';
import { Markdown } from '../Markdown';
import { type Notice, api } from '../lib/api';

/** Le texte de la notice, chargé une fois. */
export function useNotice(): Notice | null {
  const [notice, setNotice] = useState<Notice | null>(null);
  useEffect(() => {
    void api.notice().then(setNotice).catch(() => undefined);
  }, []);
  return notice;
}

export function TexteNotice({ notice }: { notice: Notice }) {
  return <div className="note-md notice"><Markdown texte={notice.texte} /></div>;
}

/** Relire la notice (Réglages). */
export function NoticeEcran() {
  const notice = useNotice();
  return (
    <main className="ecran">
      <EnTeteRetour titre="Vos données" retour="#/reglages" />
      <Fenetre>{notice ? <TexteNotice notice={notice} /> : <p className="muted" style={{ margin: 0 }}>Chargement…</p>}</Fenetre>
    </main>
  );
}

/** La notice a changé (ou n'a jamais été acceptée) : rien d'autre avant de l'avoir lue et acceptée. */
export function ConsentementEcran({ actions, apres }: { actions: Actions; apres: () => void }) {
  const notice = useNotice();
  const [lu, setLu] = useState(false);
  const accepter = async () => {
    if (!notice) return;
    try {
      await api.consentir(notice.version);
      apres();
    } catch (e) {
      actions.toast({ texte: (e as Error).message, erreur: true });
    }
  };
  return (
    <main className="ecran">
      <EnTeteRetour titre="Vos données" retour="#/" />
      <Fenetre>
        <p className="message" style={{ margin: 0 }}>Avant de continuer, voici comment Alfred s’occupe de vos données.</p>
        {notice ? <TexteNotice notice={notice} /> : <p className="muted" style={{ margin: 0 }}>Chargement…</p>}
        <label className="entretien-case">
          <input type="checkbox" checked={lu} onChange={(e) => setLu(e.target.checked)} />
          <span>J’ai lu cette notice et je l’accepte.</span>
        </label>
        <div className="boutons">
          <button className="btn principal" disabled={!lu || !notice} onClick={() => void accepter()}>Continuer</button>
          <button className="btn" onClick={() => void api.deconnexion().finally(() => { window.location.hash = '#/connexion'; window.location.reload(); })}>Me déconnecter</button>
        </div>
        <p className="muted" style={{ margin: 0, fontSize: 12 }}>
          Vous ne souhaitez pas continuer ? <a href="/api/moi/export" download>Téléchargez vos données</a>, puis supprimez votre compte depuis <a href="#/mes-donnees">Mes données</a>.
        </p>
      </Fenetre>
    </main>
  );
}
